<template>
    <div class="mt-3">
        <div class="row">
            <div class="col-sm-4 modspec_font14">Floor</div>
        </div>
        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <!------------------------------->
                <div class="row">
                    <div class="col-sm-4">
                        <select class="form-select">
                            <option value="CSOG">CSOG</option>
                            <option value="Suspended">Suspended</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Lining:
                    </div>
                    <div class="col-sm-4">
                        <select class="form-select">
                            <option value="Plywood">Plywood</option>
                            <option value="Composite">Composite</option>
                            <option value="Timber">Timber</option>
                            <option value="Custom">Custom</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Substrate:
                    </div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">Plywood</option>
                        </select>
                    </div>
                    <div class="col-sm-2">
                        <input type="text" class="form-control" placeholder="mm" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Insulation
                    </div>
                    <div class="col-sm-3 modspec_font10">
                        <input class="form-check-input" id="floorSarking" type="checkbox"><label
                            class="form-check-label modspec_font10" for="floorSarking">Sarking/Foil </label>
                    </div>
                    <div class="col-sm-3 modspec_font10">
                        <input class="form-check-input" id="floorThermal" type="checkbox"><label
                            class="form-check-label modspec_font10" for="floorThermal">Thermal Break </label>
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <input class="form-check-input" id="floorBatts" type="checkbox"><label
                            class="form-check-label modspec_font10" for="floorBatts">Batts </label>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14"></div>
                    <div class="col-sm-3 modspec_font10">
                        <input class="form-check-input" id="floorBoard" type="checkbox"><label
                            class="form-check-label modspec_font10" for="floorBoard">Board </label>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14"></div>
                    <div class="col-sm-4 modspec_font10">
                        Sarking Description:
                    </div>
                    <div class="col-sm-4 modspec_font10">
                        <input type="text" class="form-control" placeholder="i.e. Rhino Wrap" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-6 modspec_font14"></div>
                    <div class="col-sm-3 modspec_font10">
                        <label class="form-check-label modspec_font10" for="floorReflective">Reflective </label> <input
                            class="form-check-input" id="floorReflective" type="checkbox">
                    </div>
                    <div class="col-sm-3 modspec_font10">
                        <select class="form-select">
                            <option value="">Facing</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14"></div>
                    <div class="col-sm-3 modspec_font10">
                        Batts Description
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <input type="text" class="form-control" placeholder="i.e. Fletcher" />
                    </div>
                    <div class="col-sm-1 modspec_font10">
                        R-val:
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <select class="form-select">
                            <option value="">1.0</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14"></div>
                    <div class="col-sm-3 modspec_font10">
                        Board Description
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <input type="text" class="form-control" placeholder="i.e. Foil Board" />
                    </div>
                    <div class="col-sm-1 modspec_font10">
                        R-val:
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <select class="form-select">
                            <option value="">1.0</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-6 modspec_font14"></div>
                    <div class="col-sm-3 modspec_font10">
                        <label class="form-check-label modspec_font10" for="floorReflective">Reflective </label> <input
                            class="form-check-input" id="floorReflective" type="checkbox">
                    </div>
                    <div class="col-sm-3 modspec_font10">
                        <select class="form-select">
                            <option value="">Facing</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Framing:
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        Joists:
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <select class="form-select">
                            <option value="">LC15019</option>
                        </select>
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        Ctrs(mm)
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <select class="form-select">
                            <option value="">
                                450
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4">
                        <button class="btn btn-primary">Add Detail/Note +</button>
                    </div>
                </div>
                <!------------------------------->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "cd-floor",
    data: function () {
        return {
            floor: {  },
        }
    },
    mounted() {

    },
    methods: {
        test(){
            this.floor = {  };
        },

    },
}
</script>
<style></style>